import { Trans } from '@lingui/react'

import { TextButton } from '@twistopayments/design-system/components/atoms/button'
import { Typography } from '@twistopayments/design-system/components/atoms/typography'

type Props = {
  error?: string
  requiresRefresh?: boolean
  pending?: boolean
  retryRefresh: () => Promise<void>
}

export const RlcError = ({
  error,
  requiresRefresh,
  pending,
  retryRefresh,
}: Props) =>
  error ? (
    <div role="alert">
      <Typography variant="b3">{error}</Typography>
      {requiresRefresh && (
        <TextButton disabled={pending} onClick={retryRefresh}>
          <Trans id="incomeVerification.tryAgain.button" />
        </TextButton>
      )}
    </div>
  ) : null
